import actions from '../../actionTypes';

export default (payload, source) => {
  return {
    type: actions.ERROR,
    error: true,
    payload,
    source
  };
};



// WEBPACK FOOTER //
// ./src/reducers/notifications/actions/error.js